import Theme from "@/components/Theme";
import Hero from "@/organisms/Hero";
import FeatureSectionTwocol from "@/components/organisms/FeatureSectionTwocol";
import Trustpilot from "@/organisms/Trustpilot";
import Slider from "@/components/organisms/Slider";
import ServicesSectionTwoCol from "@/components/organisms/ServicesSectionTwoCol";
import RegistrationForm from "@/components/molecules/RegistrationForm";
import Discover from "@/components/organisms/Discover";
import * as womenInHvacr from "@/data/partners/women-in-hvacr";

export async function getStaticPaths() {
  const paths = [{ params: { partnersPages: "women-in-hvacr" } }];

  return {
    paths: paths,
    fallback: false,
  };
}

export async function getStaticProps({ params: { partnersPages } }) {
  let data = {};
  const contentMap = {
    "women-in-hvacr": womenInHvacr,
  };

  if (!partnersPages) {
    return {
      notFound: true,
    };
  }

  data.marketing = { ...contentMap[partnersPages]["marketing"] };
  data.content = { ...contentMap[partnersPages]["content"] };

  return {
    props: {
      data,
      pagename: partnersPages,
    },
  };
}

export default function PartnersPages({ data, pagename }) {
  const seoData = data?.marketing;
  const pagedata = data?.content;

  const hero = pagedata?.hasOwnProperty("hero") && (
    <Hero
      isFormStaticOnScroll
      heroTitle={pagedata.hero.title}
      heroContent={pagedata.hero.content}
      hasTrustpilot={pagedata.hero.hasTrustpilot}
      variant={pagedata.hero.variant}
      regFormOptions={pagedata.hero.regFormOptions}
    />
  );

  return (
    <Theme mainClassName="main" hero={hero} seo={seoData}>
      {pagedata?.hasOwnProperty("featureSectionTwocol1") && (
        <FeatureSectionTwocol
          isTitleMd
          title={pagedata.featureSectionTwocol1.title}
          image={pagedata.featureSectionTwocol1.image}
          bgColor={pagedata.featureSectionTwocol1.bgColor}
          content={pagedata.featureSectionTwocol1.content}
          isImageOnLeft={pagedata.featureSectionTwocol1.isImageOnLeft}
          hasTitleDot={pagedata.featureSectionTwocol1.hasTitleDot}
          ctaData={pagedata.featureSectionTwocol1.ctaData}
        />
      )}
      {pagedata?.hasOwnProperty("servicesSectionTwoCol") && (
        <ServicesSectionTwoCol
          bgColor={pagedata.servicesSectionTwoCol.bgColor}
          label={pagedata.servicesSectionTwoCol.label}
          title={pagedata.servicesSectionTwoCol.title}
          subText={pagedata.servicesSectionTwoCol.subText}
          listData={pagedata.servicesSectionTwoCol.listData}
          image={pagedata.servicesSectionTwoCol.image}
          contentData={pagedata.servicesSectionTwoCol.contentData}
        />
      )}
      {pagedata?.hasOwnProperty("featureSectionTwocol2") && (
        <FeatureSectionTwocol
          title={pagedata.featureSectionTwocol2.title}
          image={pagedata.featureSectionTwocol2.image}
          bgColor={pagedata.featureSectionTwocol2.bgColor}
          content={pagedata.featureSectionTwocol2.content}
          isImageOnLeft={pagedata.featureSectionTwocol2.isImageOnLeft}
          hasTitleDot={pagedata.featureSectionTwocol2.hasTitleDot}
          ctaData={pagedata.featureSectionTwocol2.ctaData}
        />
      )}
      {pagedata?.hasOwnProperty("slider") && (
        <Slider
          data={pagedata.slider.data}
          variant={pagedata.slider.variant}
          title={pagedata.slider.title}
          subTitle={pagedata.slider.subTitle}
        />
      )}
      {pagedata?.hasOwnProperty("trustPilot") && (
        <Trustpilot
          title={pagedata.trustPilot.title}
          variant={pagedata.trustPilot.variant}
        />
      )}
      {pagedata?.hasOwnProperty("miniRegister") && (
        <RegistrationForm
          title={pagedata.miniRegister.title}
          content={pagedata.miniRegister.content}
          hasBusinessNameField={false}
          variant="mini"
          formUniqueName={`page-${pagename}-mini`}
        ></RegistrationForm>
      )}
      {pagedata?.hasOwnProperty("discover") && (
        <Discover
          bgColor={pagedata.discover.bgColor}
          title={pagedata.discover.title}
          color={pagedata.discover.color}
          cta={pagedata.discover.cta}
          href={pagedata.discover.href}
        />
      )}
    </Theme>
  );
}
